import React, { Component } from 'react'
import { 
    Button,
    Box,
    FormControl,
    InputGroup,
    Input,
    InputRightElement
} from "@chakra-ui/react";
import MultiSelect from "react-multi-select-component";
import { IconTriangle, IconLocation } from "@assets/Icons";
import { SearchSlider } from '@components';
import { loadState } from "@lib/localStorage";
import { t } from '@lang/i18n';
import { dataList } from "@lib/datahandlers/global";

// Import React Script Libraray to load Google object
import Script from 'react-load-script';
import { getPredictions } from '@lib/autocomplete';
import { google_api_key } from "@config";

export default class OffersSearch extends Component {
    
    multiselect_strings = {
        allItemsAreSelected: t('multiselect.allItemsAreSelected'),
        clearSearch: t('multiselect.clearSearch'),
        noOptions: t('multiselect.noOptions'),
        search: t('multiselect.search'),
        selectAll: t('multiselect.selectAll'),
        selectSomeItems: t('multiselect.selectSomeItems'),
    }

    state = {
        fonctions: [],
        activities: [],
        contracts: [],
        selected_fonctions: [],
        selected_activities: [],
        selected_contracts: [],
        address: '',
        longitude: '',
        latitude: '',
        region: '',
        department: '',
        city: '',
        predictions: [],
        predictions_loading: false,
        show_predictions: false,
        salary_min: 0,
    }

    componentDidMount() {
        this.init();
        setTimeout(() => {
            this.setState({...this.props.params});
        }, 50); 
    };

    init = async () => {
        var data = await dataList()

        if(data) this.setState({
            fonctions:  data.fonctions .map(e => ({value: e.id, label: e.name})),
            activities: data.activities.map(e => ({value: e.id, label: e.name})),
            contracts:  data.contracts .map(e => ({value: e.id, label: e.name})),
        });
    };
    
    onPlaceSelected = (params) => {
        this.setState(prevState => {
          return { ...prevState, ...params }
        });
    };

    onSearch = async () => {
        this.props.onSearch({
            selected_fonctions:  this.state.selected_fonctions,
            selected_activities: this.state.selected_activities,
            selected_contracts:  this.state.selected_contracts,
            address:    this.state.address,
            longitude:  this.state.longitude,
            latitude:   this.state.latitude,
            region: this.state.region,
            department: this.state.department,
            city: this.state.city,
            salary_min: this.state.salary_min,
        });
    };

    // filter  multi select
    filterOptions = (options, value) => {
        if (!value) return options;
        
        const normalized_value = value.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();

        const result = options.filter((el, idx) => {
        const normalized_item = el.label.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
        if (normalized_item.includes(normalized_value)) return el
        });

        return result
    };

    onAddressChange = (text) => {
        if(!text) this.setState({ address: text, longitude: "", latitude: "", region: "", department: "", city: ""})
        else this.setState({ address: text })
    };
    
    render() {
        return (
            <Box display={this.props.display || "flex"} flexDir="row" justifyContent="space-between" alignItems="flex-start" flexWrap="wrap" mb="20px">
                <FormControl id="fonctions" isRequired mx={["auto","","","0"]} mb="1.625rem" w={["90vw", "20rem"]}>
                    <MultiSelect
                        options={this.state.fonctions}
                        value={this.state.selected_fonctions}
                        onChange={selected => this.setState({selected_fonctions: selected})}
                        ArrowRenderer={() => <IconTriangle iconType="candidate" position="down" />}
                        filterOptions={this.filterOptions}
                        valueRenderer={val => !val.length? t('fields.candidates.metier') : null}
                        className={("className", "multi-select candidate search")}
                        overrideStrings={this.multiselect_strings} />
                </FormControl>

                <FormControl id="activities" isRequired mx={["auto","","","0"]} mb="1.625rem" w={["90vw", "20rem"]}>
                    <MultiSelect
                        options={this.state.activities}
                        value={this.state.selected_activities}
                        onChange={selected => this.setState({selected_activities: selected})}
                        ArrowRenderer={() => <IconTriangle iconType="candidate" position="down" />}
                        filterOptions={this.filterOptions}
                        valueRenderer={val => !val.length? t('fields.candidates.activities') : null}
                        className={("className", "multi-select candidate search")}
                        overrideStrings={this.multiselect_strings} />
                </FormControl>

                <Script url={`https://maps.googleapis.com/maps/api/js?key=${google_api_key}&libraries=places`}
                    onLoad={() => getPredictions({ inputId:'autocomplete', callback: this.onPlaceSelected })}
                />
                <FormControl id="address" isRequired mx={["auto","","","0"]} mb="1.625rem" w={["90vw", "20rem"]}>
                    <InputGroup>
                        <Input
                            autoComplete='off'
                            id="autocomplete"
                            type="text"
                            name="address"
                            maxW="20rem"
                            placeholder="Ville, département, région..."
                            _placeholder={{color:'#AAA'}}
                            borderColor="gray.borders"
                            _hover={{}}
                            borderRadius="3px" h="38px"
                            focusBorderColor="blue.light"
                            value={this.state.address}
                            onChange={e => this.onAddressChange(e.target.value)}
                        />
                            <InputRightElement children={<IconLocation iconType="candidate" />} top="0" />
                    </InputGroup>
                </FormControl>

                <FormControl id="contracts" isRequired mx={["auto","","","0"]} mb="1.625rem" w={["90vw", "20rem"]}>
                    <MultiSelect
                        options={this.state.contracts}
                        value={this.state.selected_contracts}
                        onChange={selected => this.setState({selected_contracts: selected})}
                        ArrowRenderer={() => <IconTriangle iconType="candidate" position="down" />}
                        valueRenderer={val => !val.length? t('fields.candidates.contracts') : null}
                        className={("className", "multi-select candidate search")}
                        overrideStrings={this.multiselect_strings} />
                </FormControl>

                <SearchSlider 
                    salary_min={this.state.salary_min} 
                    onChange={salary_min => this.setState({salary_min})}
                    mx={["auto","","","0"]} mb="1.625rem" w={["90vw", "20rem"]}/>

                <Button
                    type="submit"
                    bg="blue.main"
                    borderRadius="1.5rem"
                    textColor="white"
                    mx={["auto","","","0"]}
                    w={["90vw", "20rem"]}
                    h="38px"
                    lineHeight="100%"
                    _hover={{ opacity: .8 }}
                    onClick={() => this.onSearch()}>
                    {t('company.search_candidates.search')}
                </Button>
            </Box>
        )
    }
}
